module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "modal fade modal-terms-conditions",
    attrs: {
      "tabindex": "-1",
      "role": "dialog",
      "data-keyboard": "false",
      "data-backdrop": "static"
    }
  }, [_c('div', {
    staticClass: "modal-dialog modal-lg",
    attrs: {
      "role": "document"
    }
  }, [_c('div', {
    staticClass: "modal-content"
  }, [_c('div', {
    staticClass: "modal-header"
  }, [_c('h4', {
    staticClass: "modal-title"
  }, [_vm._v("Terms and Conditions for Carriers (" + _vm._s(_vm.publishedDecorated.version) + ")")])]), _vm._v(" "), _c('div', {
    staticClass: "modal-body"
  }, [_c('p', {
    staticClass: "lead"
  }, [_vm._v("\n          Last updated: " + _vm._s(_vm.publishedDecorated.formatted_published_at) + "\n          "), (_vm.userHasAcceptedTerms) ? _c('span', {
    staticClass: "m-l-lg"
  }, [_vm._v("\n            Accepted at: " + _vm._s(_vm.authorized.agreed_on) + "\n          ")]) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "content",
    domProps: {
      "innerHTML": _vm._s(_vm.publishedDecorated.content)
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "modal-footer"
  }, [(_vm.userHasAcceptedTerms) ? _c('button', {
    staticClass: "btn btn-info",
    attrs: {
      "type": "button",
      "data-dismiss": "modal"
    }
  }, [_vm._v("Close")]) : [_c('ladda-button', {
    attrs: {
      "type": "danger",
      "on-click": _vm.handleDoNotAcceptTerms
    }
  }, [_vm._v("Don't Accept")]), _vm._v(" "), _c('ladda-button', {
    attrs: {
      "type": "success",
      "on-click": _vm.handleAcceptTerms
    }
  }, [_vm._v("Accept")])]], 2)])])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ../~/vue-loader/lib/template-compiler?{"id":"data-v-9bb24d2c"}!../~/vue-loader/lib/selector.js?type=template&index=0!./src/components/TermsAndConditions.vue
// module id = 1066
// module chunks = 0